module.exports = __webpack_public_path__ + "static/img/play_title.63977c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/play_title.png
// module id = 1iUU
// module chunks = 0